import {
  lineStatusLabel,
  requestStatusLabel,
  statusBadgeClass,
} from '../lib/requestLineStatus'
import type { ProductionRequestLineStatus, ProductionRequestStatus } from '../types/records'

type Props =
  | { kind: 'request'; status: ProductionRequestStatus | string | undefined }
  | { kind: 'line'; status: ProductionRequestLineStatus | string | undefined }

export function ProductionStatusBadge(props: Props) {
  const label = props.kind === 'request' ? requestStatusLabel(props.status) : lineStatusLabel(props.status)
  return <span className={statusBadgeClass(props.kind, props.status)}>{label}</span>
}
